import React, { useState, useEffect } from 'react';
import { Modal, Box, TextField, Button, Typography, FormControlLabel, Switch, IconButton } from "@mui/material";
import { ModalBox } from '../../../styles/ModalStyles';
import CloseIcon from '@mui/icons-material/Close';

const EditarPaisModal = ({ open, onClose, onSubmit, pais }) => {
  const [nombre, setNombre] = useState('');
  const [codigoISO, setCodigoISO] = useState('');
  const [habilitado, setHabilitado] = useState(false);

  useEffect(() => {
    if (pais) {
      setNombre(pais.nombre);
      setCodigoISO(pais.codigoISO);
      setHabilitado(pais.habilitado);
    }
  }, [pais]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ ...pais, nombre, codigoISO, habilitado });
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant='h6'>Editar País</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Código ISO"
            value={codigoISO}
            onChange={(e) => setCodigoISO(e.target.value.toUpperCase())}
            margin="normal"
            required
            inputProps={{ maxLength: 3 }}
            helperText="Ejemplo: CHL, USA, ESP"
          />
          <FormControlLabel
            control={
              <Switch
                checked={habilitado}
                onChange={(e) => setHabilitado(e.target.checked)}
                color="primary"
              />
            }
            label={habilitado ? "Habilitado" : "Deshabilitado"}
          />
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button type="submit" variant="contained" color="primary" sx={{ mr: 1 }}>
              Guardar
            </Button>
            <Button onClick={onClose} variant="contained" color="error">
              Cancelar
            </Button>
          </Box>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default EditarPaisModal;